import React from 'react';
import { useState } from 'react';
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import { useNavigate , Link } from 'react-router-dom';
import EmployerNavbar from '../../../../components/Profile-navbar/employer-navbar';
import { FaArrowLeft } from 'react-icons/fa';
import "./postjobs.css"


function PostJobPage() {
  const [job, setJob] = useState({
    title: '',
    company: '',
    workPlaceType: '',
    location: '',
    workType: '',
    experience: '',
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setJob((prevJob) => ({ ...prevJob, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Add logic to submit the form data to your backend
  };

  const navigate = useNavigate();


  return (
    <div >
      <EmployerNavbar/>
       
    <Container fluid className='p-5'>
      <h1 >Post a Job</h1>
      <Form onSubmit={handleSubmit} className='mt-5'>
        <Row className='gap-0 gap-sm-5'>
          
          <Col xs={12} sm={true}>
            <Form.Group className='mb-5' controlId="formJobTitle">
              <Form.Label className='label'>Job Title</Form.Label>
              <Form.Control type="text" name="title" value={job.title} onChange={handleInputChange} placeholder="Enter job title"  className='py-2'/>
            </Form.Group>
            <Form.Group className='mb-5'controlId="formCompany">
              <Form.Label className='label'>Company</Form.Label>
              <Form.Control type="text" name="company" value={job.company} onChange={handleInputChange} placeholder="Enter company name"  className='py-2'/>
          
            </Form.Group>
            <Form.Group className='mb-5'controlId="formLocation">
              <Form.Label className='label'>Job Location</Form.Label>
              <Form.Select >
      <option>Select Location</option>
      <option value="1">Lagos, Nigeria</option>
      <option value="2">Paris, Freelance</option>
      <option value="3">Cape Town, South Africa</option>
    </Form.Select>
              </Form.Group>
            <Form.Group className='mb-5'controlId="formWorkPlaceType">
              <Form.Label className='label'>Work Place Type</Form.Label>
              <Form.Select >
      <option>Select Work Place Type</option>
      <option value="1">Remote</option>
      <option value="2">Hybrid</option>
      <option value="3">Monday-Friday</option>
    </Form.Select>
              </Form.Group>
              <Form.Group className='mb-5'controlId="formWorkType">
              <Form.Label className='label'>Job Type</Form.Label>
              <Form.Select >
      <option>Select Job Type</option>
      <option value="1">Full-Time</option>
      <option value="2">Part-Time</option>
      
    </Form.Select>
            </Form.Group>
          </Col>
        
          
          <Col xs={12} sm={true}>
           
          <Form.Group className='mb-5' controlId="formJobTitle">
              <Form.Label className='label'>Job Category</Form.Label>
              <Form.Control type="text" name="title" value={job.category} onChange={handleInputChange} placeholder="Enter job category"  className='py-2'/>
            </Form.Group>
              <Form.Group className='mb-5'controlId="formExperience">
              <Form.Label className='label'>Experience Level</Form.Label>
              <Form.Select >
      <option>Level of Experience</option>
      <option value="1">Expert</option>
      <option value="2">Intermediate</option>
      <option value="3">Beginner</option>
    </Form.Select>
            </Form.Group>
            <Form.Group className='mb-5'controlId="">
              <Form.Label className='label'>Qualifications</Form.Label>
              <Form.Control type="text" name="qualifications" value={job.qualifications} onChange={handleInputChange} placeholder="Enter required qualifications"  className='py-2'/>
          
            </Form.Group>
            <Form.Group className='mb-5'controlId="">
              <Form.Label className='label'>Job Description</Form.Label>
              <Form.Control type="text" name="description" value={job.description} onChange={handleInputChange} placeholder="Enterjob description"  className='py-2'/>
          
            </Form.Group>
            <Form.Group className='mb-5'controlId="">
              <Form.Label className='label'>Salary Range</Form.Label>
              <Form.Control type="text" name="salary" value={job.salary} onChange={handleInputChange} placeholder="Enter range of salary"  className='py-2'/>
          
            </Form.Group>
          </Col>
          
       
          
        </Row>
        <div className='d-flex align-items-center justify-content-center mt-3'>
            <Link to="/jobdescription" className='next-button'>
             Next
            </Link>
          </div>
      
      </Form>
    </Container>

    </div>
  );
}

export default PostJobPage;
